import React from 'react';
import { Card } from './ui/card';
import { MonitorPlay, Sparkles, Zap, Clock } from 'lucide-react';
import { benefits } from '../mock';

const iconMap = {
  MonitorPlay: MonitorPlay,
  Sparkles: Sparkles,
  Zap: Zap,
  Clock: Clock
};

const Benefits = () => {
  return (
    <section className="py-16 md:py-24 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
            Por Que Escolher o <span className="text-red-600">Apex Stream?</span>
          </h2>
          <p className="text-gray-400 text-lg md:text-xl max-w-2xl mx-auto">
            A melhor experiência de streaming que você pode ter
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {benefits.map((benefit) => {
            const IconComponent = iconMap[benefit.icon];
            return (
              <Card
                key={benefit.id}
                className="bg-zinc-900 border-zinc-800 p-6 md:p-8 hover:border-red-600 transition-all duration-300 hover:scale-105 group cursor-pointer"
              >
                <div className="bg-red-600/10 w-14 h-14 rounded-lg flex items-center justify-center mb-6 group-hover:bg-red-600 transition-colors">
                  <IconComponent className="w-7 h-7 text-red-600 group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-red-500 transition-colors">
                  {benefit.title}
                </h3>
                <p className="text-gray-400 leading-relaxed">{benefit.description}</p>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
